/* eslint-disable indent */

import { Component } from '@verndale/core';
import { constEvent } from '../utils/constants';
import axios from 'axios';
import { dispatchGenericEvent } from '../utils/dispatch-events';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $hamburger: this.el._$('.header__hamburger'),
      $sidePanelClose: this.el._$('.header__side-panel-close'),
      $shippingTrigger: this.el._$$('.account-utility-nav__shipping-trigger'),
      $navTrigger: this.el._$$('.account-utility-nav__subnav-trigger'),
      $navCloseTrigger: this.el._$$('.account-utility-nav-subnav__close'),
      $primaryNav: this.el._$('.primary-nav-panel-tablet'),
      $cart: this.el._$('.header__items-in-cart'),
      $cartWrapper: this.el._$('.header__cart'),
      $newAccount: this.el._$('.account-utility-nav-subnav__new-account')
    };

    this.sidePanelExpandedClass = 'header-side-panel-opened';
    this.primaryNavPanelOpenedClass = 'header-primary-nav-panel-opened';
    this.expandedSubnavClass = 'account-utility-nav__item--expanded';
    this.cartHideClass = 'header__items-in-cart--hidden';

    this.updateHeaderCartDisplay();
  }

  addListeners() {
    this.dom.$hamburger._on('click', this.opensidePanel.bind(this));
    this.dom.$sidePanelClose._on('click', this.closesidePanel.bind(this));
    this.dom.$navTrigger._on('click', this.handleSubnavDisplay.bind(this));
    this.dom.$navCloseTrigger._on('click', this.closeSubNav.bind(this));
    this.dom.$cartWrapper._on('click', this.onCartClick.bind(this));
    this.dom.$shippingTrigger?._on?.(
      'click',
      this.onShippingAddressClick.bind(this)
    );
    if (this.dom.$newAccount)
      this.dom.$newAccount._on('click', this.onNewAccountApply.bind(this));
    document._on('click', this.handleClickOutside.bind(this), false);
    document._on(constEvent.ADDED_TO_CART, this.updateCart.bind(this));
    document._on(constEvent.ADDED_TO_CART_LGC, this.updateCart.bind(this));
    document._on(constEvent.REMOVED_FROM_CART, this.updateCart.bind(this));
    document._on(
      constEvent.NEW_ACCOUNT_LINKED,
      this.rebindAccountNavs.bind(this)
    );
    document._on(
      constEvent.UPDATE_CART_INDICATOR,
      this.updateCartIndicator.bind(this)
    );
    document._on(
      constEvent.ADDED_TO_CART_HEPATOCYTE,
      this.updateCart.bind(this)
    );
  }

  rebindAccountNavs() {
    _$('.account-utility-nav__account-trigger')._on(
      'click',
      this.handleSubnavDisplay.bind(this)
    );
    _$('.account-utility-nav__shipping-trigger')?._on?.(
      'click',
      this.onShippingAddressClick.bind(this)
    );
    _$('.account-utility-nav-subnav__new-account')?._on?.(
      'click',
      this.onNewAccountApply.bind(this)
    );
    _$('.account-utility-nav__account')
      ._$('.account-utility-nav-subnav__close')
      ._on('click', this.closeSubNav.bind(this));
  }

  opensidePanel() {
    document.body.classList.add(this.sidePanelExpandedClass);
    this.dom.$primaryNav.innerHTML = '';
  }

  closesidePanel() {
    document.body.classList.remove(this.sidePanelExpandedClass);
  }

  handleSubnavDisplay(e) {
    const $parent = e.target.closest('.account-utility-nav__item--has-subnav');

    if ($parent?.classList?.contains?.(this.expandedSubnavClass)) {
      this.closeSubNav(e);
    } else {
      this.openSubNav(e);
    }
  }

  openSubNav(e) {
    this.closeSubNav();
    const $parent = e.target.closest('.account-utility-nav__item--has-subnav');
    if (!$parent) return;
    if ($parent.classList.contains(this.expandedSubnavClass)) return;
    $parent.classList.add(this.expandedSubnavClass);
  }

  closeSubNav(e) {
    if (e) {
      const $parent = e.target.closest(
        '.account-utility-nav__item--has-subnav'
      );
      if ($parent) {
        $parent.classList.remove(this.expandedSubnavClass);
      }
    } else {
      const el = this.el._$(`.${this.expandedSubnavClass}`);
      if (el) el.classList.remove(this.expandedSubnavClass);
    }
  }

  handleClickOutside(e) {
    if (e.target.closest('.account-utility-nav-subnav')) return;
    if (
      e.target.closest(`.${this.expandedSubnavClass}`) &&
      e.target.closest('.account-utility-nav__subnav-trigger')
    )
      return;
    this.closeSubNav();
  }

  updateHeaderCartDisplay() {
    let count = parseInt(this.dom.$cart.textContent, 10);
    if (isNaN(count)) count = 0;

    if (count) {
      this.dom.$cart.classList.remove(this.cartHideClass);
      this.dom.$cart.textContent = count;
    } else {
      this.dom.$cart.classList.add(this.cartHideClass);
    }
  }

  updateCart(e) {
    const count =
      e?.detail?.cart?.allItems?.count || e?.detail?.cart?.items?.count || null;

    if (count) {
      this.dom.$cart.classList.remove(this.cartHideClass);
      this.dom.$cart.textContent = count;
    } else {
      this.dom.$cart.classList.add(this.cartHideClass);
    }
  }

  updateCartIndicator(e) {
    const { detail } = e;

    if (detail) {
      this.dom.$cart.classList.remove(this.cartHideClass);
      this.dom.$cart.textContent = detail;
    } else {
      this.dom.$cart.classList.add(this.cartHideClass);
    }
  } //updateCartIndicator

  async onNewAccountApply(e) {
    e.preventDefault();
    const el = e.currentTarget;
    const { data } = await axios(el.dataset.api);

    if (data?.success) {
      if (data?.body?.action === 'redirect') {
        window.location.href = data?.body?.actionValue;
      } else {
        dispatchGenericEvent(
          constEvent.SHOW_MODAL_EXISTING_PENDING_ACCOUNT_APLICATION,
          { continueButtonUrl: data?.body?.continueButtonUrl }
        );
      }
    }
  }

  post(endpoint, data) {
    return axios({
      method: 'post',
      url: endpoint,
      data,
      headers: {
        'content-type': 'application/json'
      }
    });
  }

  onCartClick(e) {
    const api = this.dom.$cartWrapper?.dataset?.lgcCartEndpoint;

    if (!api) return;
    e.preventDefault();

    this.post(api).then(response => {
      const { success, body } = response?.data;

      if (success) {
        const { dispatchEvent } = body;
        if (dispatchEvent) {
          dispatchGenericEvent(dispatchEvent, body);
        }
      }
    });
  }

  onShippingAddressClick() {
    dispatchGenericEvent(constEvent.SHOW_MODAL_CHANGE_ADDRESS);
  }
}

export default Module;

export const updateLinkedAccounts = data => {
  const $associateApply = _$('.account-utility-nav__associate-apply');
  const $account = _$('.account-utility-nav__account');
  const $shipping = _$('.account-utility-nav__shipping');
  const $linkedAccounts = _$('.header-linked-account-template').innerHTML;
  const $temp = document.createElement('div');
  const $utilityNav = _$('.account-utility-nav');
  const expandedSubnavClass = 'account-utility-nav__item--expanded';
  const renderLi = item => `
    <li class="account-utility-nav-select__item ${
      item.selected ? 'account-utility-nav-select__item--selected' : ''
    }">
      <a href="${item.url}" class="account-utility-nav-select__link">
        <span class="account-utility-nav-select__faux-radio"></span>
        <span class="account-utility-nav-select__text">${item.name}</span>
      </a>
    </li>
  `;

  $temp.innerHTML = $linkedAccounts;
  const $items = $temp._$$('.account-utility-nav__item');

  if ($associateApply) {
    $associateApply.remove();
  } else if ($account) {
    $account.remove();
    $shipping.remove();
  }

  $utilityNav.append($items[0]);
  $utilityNav.append($items[1]);
  $items[0].classList.remove(expandedSubnavClass);

  const $nickname = $utilityNav._$('.account-utility-nav__account-nickname');
  const $container = $utilityNav._$('.account-utility-nav-select__items');
  const $shippingAddress = $utilityNav._$(
    '.account-utility-nav__shipping-address'
  );
  const $links = data.linkedAccounts.map(a => renderLi(a)).join('');
  $container.innerHTML = $links;
  $nickname.textContent = data.nickname;
  $shippingAddress.textContent = data.shipping;

  dispatchGenericEvent(constEvent.NEW_ACCOUNT_LINKED, data);
};
